// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dd-wrap {
  position: relative;
  display: inline-block;
}

.dd-menu {
  background: var(--bg);
  border: 1px solid var(--border);
  border-radius: 0;
  box-shadow: var(--shadow);
  padding: 4px 0;
  width: 240px;
  overflow: hidden;
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: var(--z-dropdown);
}

.dd-menu--dark {
  background: var(--ink-dark-2);
  border-color: var(--ink-rule);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.45);
}

.dd-menu__item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  font-size: var(--fs-2xs);
  color: var(--text-secondary);
  cursor: pointer;
  background: none;
  border: none;
  width: 100%;
  text-align: left;
  font-family: inherit;
}

.dd-menu__item:hover,
.dd-menu__item--focused {
  background: var(--bg-alt);
  color: var(--text);
}

.dd-menu--dark .dd-menu__item {
  color: var(--ink-text-2);
}
.dd-menu--dark .dd-menu__item:hover,
.dd-menu--dark .dd-menu__item--focused {
  background: var(--ink-dark);
  color: var(--ink-text);
}

.dd-menu__ico {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: var(--text-muted);
  flex-shrink: 0;
}
/* SVG icons inherit the muted menu-icon color via currentColor. */
.dd-menu__ico svg {
  width: 100%;
  height: 100%;
}

.dd-menu__kbd {
  margin-left: auto;
  font-family: var(--mono);
  font-size: var(--fs-micro);
  background: var(--bg-alt);
  border: 1px solid var(--border);
  color: var(--text-muted);
  padding: 1px 5px;
  border-radius: 2px;
}

.dd-menu--dark .dd-menu__kbd {
  background: var(--ink-dark);
  border-color: var(--ink-rule);
  color: var(--ink-text-3);
}

.dd-menu__sep {
  height: 1px;
  background: var(--border);
  margin: 4px 0;
}

.dd-menu--dark .dd-menu__sep {
  background: var(--ink-rule);
}

.dd-menu__label {
  padding: 6px 14px 4px;
  font-family: var(--mono);
  font-size: var(--fs-nano);
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: var(--text-muted);
}

.dd-menu--dark .dd-menu__label {
  color: var(--ink-text-3);
}

/* Org header — avatar + org name + capability subtitle (account menu). */
.dd-menu__header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px 11px;
}
.dd-menu__header-av {
  width: 30px;
  height: 30px;
  flex: none;
  display: grid;
  place-items: center;
  background: var(--accent, #0c6bf0);
  color: var(--accent-ink, #fff);
  font-family: var(--mono);
  font-size: var(--fs-sm);
  font-weight: 600;
}
.dd-menu__header-info {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.dd-menu__header-title {
  font-size: var(--fs-ui);
  font-weight: 600;
  color: var(--text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dd-menu__header-meta {
  font-family: var(--mono);
  font-size: var(--fs-nano);
  letter-spacing: 0.06em;
  color: var(--text-muted);
}
.dd-menu--dark .dd-menu__header-title {
  color: var(--ink-text);
}
.dd-menu--dark .dd-menu__header-meta {
  color: var(--ink-text-3);
}

/* Identity block — person name + role · email. */
.dd-menu__userblock {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 7px 14px 8px;
}
.dd-menu__userblock-name {
  font-size: var(--fs-2xs);
  font-weight: 500;
  color: var(--text);
}
.dd-menu__userblock-meta {
  font-family: var(--mono);
  font-size: var(--fs-nano);
  letter-spacing: 0.02em;
  color: var(--text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dd-menu--dark .dd-menu__userblock-name {
  color: var(--ink-text);
}
.dd-menu--dark .dd-menu__userblock-meta {
  color: var(--ink-text-3);
}
`, "",{"version":3,"sources":["webpack://./src/ui/Dropdown/Dropdown.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,wBAAwB;EACxB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;AACA;;EAEE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,cAAc;AAChB;AACA,kEAAkE;AAClE;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,+BAA+B;EAC/B,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,8BAA8B;EAC9B,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;AACvB;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B","sourcesContent":[".dd-wrap {\n  position: relative;\n  display: inline-block;\n}\n\n.dd-menu {\n  background: var(--bg);\n  border: 1px solid var(--border);\n  border-radius: 0;\n  box-shadow: var(--shadow);\n  padding: 4px 0;\n  width: 240px;\n  overflow: hidden;\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  z-index: var(--z-dropdown);\n}\n\n.dd-menu--dark {\n  background: var(--ink-dark-2);\n  border-color: var(--ink-rule);\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.45);\n}\n\n.dd-menu__item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 14px;\n  font-size: var(--fs-2xs);\n  color: var(--text-secondary);\n  cursor: pointer;\n  background: none;\n  border: none;\n  width: 100%;\n  text-align: left;\n  font-family: inherit;\n}\n\n.dd-menu__item:hover,\n.dd-menu__item--focused {\n  background: var(--bg-alt);\n  color: var(--text);\n}\n\n.dd-menu--dark .dd-menu__item {\n  color: var(--ink-text-2);\n}\n.dd-menu--dark .dd-menu__item:hover,\n.dd-menu--dark .dd-menu__item--focused {\n  background: var(--ink-dark);\n  color: var(--ink-text);\n}\n\n.dd-menu__ico {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  color: var(--text-muted);\n  flex-shrink: 0;\n}\n/* SVG icons inherit the muted menu-icon color via currentColor. */\n.dd-menu__ico svg {\n  width: 100%;\n  height: 100%;\n}\n\n.dd-menu__kbd {\n  margin-left: auto;\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  background: var(--bg-alt);\n  border: 1px solid var(--border);\n  color: var(--text-muted);\n  padding: 1px 5px;\n  border-radius: 2px;\n}\n\n.dd-menu--dark .dd-menu__kbd {\n  background: var(--ink-dark);\n  border-color: var(--ink-rule);\n  color: var(--ink-text-3);\n}\n\n.dd-menu__sep {\n  height: 1px;\n  background: var(--border);\n  margin: 4px 0;\n}\n\n.dd-menu--dark .dd-menu__sep {\n  background: var(--ink-rule);\n}\n\n.dd-menu__label {\n  padding: 6px 14px 4px;\n  font-family: var(--mono);\n  font-size: var(--fs-nano);\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  color: var(--text-muted);\n}\n\n.dd-menu--dark .dd-menu__label {\n  color: var(--ink-text-3);\n}\n\n/* Org header — avatar + org name + capability subtitle (account menu). */\n.dd-menu__header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px 11px;\n}\n.dd-menu__header-av {\n  width: 30px;\n  height: 30px;\n  flex: none;\n  display: grid;\n  place-items: center;\n  background: var(--accent, #0c6bf0);\n  color: var(--accent-ink, #fff);\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  font-weight: 600;\n}\n.dd-menu__header-info {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.dd-menu__header-title {\n  font-size: var(--fs-ui);\n  font-weight: 600;\n  color: var(--text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.dd-menu__header-meta {\n  font-family: var(--mono);\n  font-size: var(--fs-nano);\n  letter-spacing: 0.06em;\n  color: var(--text-muted);\n}\n.dd-menu--dark .dd-menu__header-title {\n  color: var(--ink-text);\n}\n.dd-menu--dark .dd-menu__header-meta {\n  color: var(--ink-text-3);\n}\n\n/* Identity block — person name + role · email. */\n.dd-menu__userblock {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 7px 14px 8px;\n}\n.dd-menu__userblock-name {\n  font-size: var(--fs-2xs);\n  font-weight: 500;\n  color: var(--text);\n}\n.dd-menu__userblock-meta {\n  font-family: var(--mono);\n  font-size: var(--fs-nano);\n  letter-spacing: 0.02em;\n  color: var(--text-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.dd-menu--dark .dd-menu__userblock-name {\n  color: var(--ink-text);\n}\n.dd-menu--dark .dd-menu__userblock-meta {\n  color: var(--ink-text-3);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
